export default __webpack_public_path__ + "static/media/no-data.746fd765.png";